import { accessRole } from "../../../helpers/access_role"
import ErrorAccess from '../../../components/Error/Content/Access'

import IndexView from "./Index/View"

const RouteView = (props) => {

  return accessRole('read') ? <IndexView /> : <ErrorAccess />
}
export default RouteView